//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const CircleArrowUpFilled = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="CircleArrowUpFilled"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#prefix__clip0_24691_396)">
            <path
              d="M12.0001 1.07193C13.2068 1.76862 14.2105 2.76837 14.912 3.9722C15.6135 5.17604 15.9885 6.54221 15.9997 7.93548C16.011 9.32876 15.6582 10.7008 14.9762 11.9158C14.2942 13.1308 13.3068 14.1467 12.1115 14.8628C10.9163 15.5788 9.55481 15.9704 8.16178 15.9986C6.76875 16.0268 5.39251 15.6906 4.16929 15.0235C2.94608 14.3563 1.91832 13.3813 1.18775 12.1949C0.457175 11.0085 0.049128 9.6518 0.00400014 8.25922L0 8.00001L0.00400014 7.74081C0.0488032 6.35918 0.450844 5.01274 1.17093 3.83276C1.89101 2.65277 2.90456 1.6795 4.11276 1.00783C5.32097 0.336168 6.6826 -0.0109688 8.0649 0.0002642C9.44721 0.0114972 10.803 0.380717 12.0001 1.07193ZM8.0161 3.99996L7.8857 4.00796L7.8169 4.02076L7.70329 4.05676L7.61289 4.09996L7.55689 4.13437L7.48089 4.19117L7.43449 4.23437L4.23445 7.43441L4.16805 7.50961C4.04372 7.6704 3.98526 7.87249 4.00453 8.07483C4.02381 8.27717 4.11938 8.46459 4.27183 8.59902C4.42428 8.73345 4.62219 8.80481 4.82535 8.7986C5.02851 8.7924 5.2217 8.7091 5.36567 8.56562L7.20009 6.7312V11.2001L7.20569 11.2937C7.22977 11.4961 7.33026 11.6818 7.48663 11.8126C7.64299 11.9435 7.84343 12.0097 8.04698 11.9978C8.25054 11.9858 8.44185 11.8966 8.58183 11.7484C8.7218 11.6001 8.79988 11.404 8.80011 11.2001V6.732L10.6345 8.56562L10.7097 8.63202C10.8705 8.75635 11.0726 8.81482 11.275 8.79554C11.4773 8.77627 11.6647 8.6807 11.7991 8.52824C11.9336 8.37579 12.0049 8.17788 11.9987 7.97472C11.9925 7.77156 11.9092 7.57837 11.7657 7.43441L8.56571 4.23437L8.5001 4.17597L8.4289 4.12476L8.3385 4.07516L8.2737 4.04796L8.1833 4.02076L8.0937 4.00476L8.0153 3.99996H8.0161Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="prefix__clip0_24691_396">
              <rect width={16} height={16} fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};
